export const environment = {
  "production": false,
  "testing": false,
  "localhost": true,
  "firebase": {
    "apiKey": "AIzaSyDlWlntd9P8kQ5TuUL1gQfm-2cH-MdNf4A",
    "authDomain": "kocursoft-erp-testing.firebaseapp.com",
    "projectId": "kocursoft-erp-testing",
    "storageBucket": "kocursoft-erp-testing.firebasestorage.app",
    "messagingSenderId": "535795956267",
    "appId": "1:535795956267:web:b291b57d809e74c555486e",
    "measurementId": "G-Y3GGQ06CPE"
  },
  "apiUrl": "https://api-erp-v2-testing-255625776900.southamerica-west1.run.app/v1/",
  "apiUrlUpload": "https://api-upload-file-255625776900.southamerica-west1.run.app/gcp/public/upload",
  "urlAuth": "https://auth.sandbox.kocursoft.com"
};
